import { appColorsIcon } from './colors';
import { appFlashIcon } from './flash';
export const imagesIcons = [appColorsIcon, appFlashIcon];
